import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useProduct } from '@/api/products'
import { useWorkspace } from '@/api/workspace'
import { LoadingSkeleton } from '@/components/loading-skeleton'
import { ProductForm } from '@/components/products/product-form'

// Product edit (UI-SCREENS P-02, #99). Owner only; the code stays editable, not audited (#98 Q3).
export const Route = createFileRoute('/w/$slug/products/$productId/edit')({
  component: EditProduct,
  staticData: { breadcrumb: 'products.form.editTitle' },
})

function EditProduct() {
  const { t } = useTranslation()
  const { slug, productId } = Route.useParams()
  const workspace = useWorkspace(slug)
  const product = useProduct(slug, Number(productId))

  if (workspace.data && workspace.data.role !== 'owner') {
    return <Navigate to="/w/$slug/products/$productId" params={{ slug, productId }} replace />
  }

  return (
    <section className="flex flex-col gap-4">
      <h1 className="font-heading text-xl font-semibold">{t('products.form.editTitle')}</h1>
      {product.isPending ? (
        <LoadingSkeleton variant="form" rows={4} />
      ) : product.isError || !product.data ? (
        <p role="alert" className="text-sm text-destructive">
          {t('errors.generic')}
        </p>
      ) : (
        <ProductForm slug={slug} product={product.data} />
      )}
    </section>
  )
}
